// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1z2AI","sticky":"Menu_sticky__3GpKr","icons":"Menu_icons__3LBpT","userLogin":"Menu_userLogin__3wRfU"};